import React from 'react';
import styles from './ContactOptions.module.scss';
import { RichText } from '../../../scripts/contentful';

export const toSearchString = (searchParams = {}) => {
  return Object.keys(searchParams)
    .map((key) => `${key}=${encodeURIComponent(searchParams[key])}`)
    .join('&');
};

export const createMailtoLink = (email, headers) => {
  let link = `mailto:${email}`;
  if (headers) {
    link += `?${toSearchString(headers)}`;
  }
  return link;
};

const ContactOptions = ({
  setActive,
  contactCompanyTitle,
  contactCompanyAbstract,
  contactProjectTitle,
  contactProjectAbstract,
  contactSupportTitle,
  contactSupportAbstract,
}) => {
  const mailto = (event) => {
    event.preventDefault();
    setActive(null);
    window.location.href = createMailtoLink('tech@abecedaire-studio.com');
  };

  return (
    <section className={styles.ContactOptions}>
      <div className={`${styles.ContactOptions__content} layout row`}>
        <div className={styles.ContactOptions__content__options}>
          <h2>{contactCompanyTitle}</h2>
          <RichText content={contactCompanyAbstract} />

          <button
            name='Devis'
            id='t-devisChoice'
            onClick={() => setActive({ color: 'blue', type: 2 })}
          >
            Prise de contact
          </button>
        </div>
        <div className={styles.ContactOptions__content__options}>
          <h2>{contactProjectTitle}</h2>
          <RichText content={contactProjectAbstract} />

          <button
            name='Contact'
            id='t-contactChoice'
            onClick={() => setActive({ color: 'purple', type: 1 })}
          >
            Contacter ABECEDAIRE
          </button>
        </div>
        <div className={styles.ContactOptions__content__options}>
          <h2>{contactSupportTitle}</h2>
          <RichText content={contactSupportAbstract} />

          <a
            onClick={(e) => mailto(e)}
            id='t-supportChoice'
            href='mailto:obfuscated'
          >
            Contacter le support
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactOptions;
